import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { formConstant } from '../../../../../../config';
import { cellPhoneValidatorNew, emailValidator } from '../../../../../core/helpers/helpers.function';
import { ICountry } from '../../../../../core/models/country.interface';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UserService } from '../../../../../core/services/user.service';
import { IService, IVendor } from '../../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../../services/shipment-price.service';

@Component({
    selector: 'eci-vendor',
    templateUrl: './vendor.component.html',
    styleUrls: ['./vendor.component.scss']
})
export class VendorComponent implements OnInit {

    public isActive: boolean = false;
    public showLoader = false;
    public createMode: boolean = false;
    public vendor: IVendor;
    public form: FormGroup;
    public title = 'Vendor';
    public nameMaxLength = formConstant.textFieldMaxLength120;

    public services: IService[] = [];
    public countries: ICountry[] = [];
    private phoneObj: any;

    public searchCountry: FormControl = new FormControl('');
    public searchService: FormControl = new FormControl('');

    private errorHandler = (err) => {
        this.notify.showError(err.error.message);
        this.showLoader = false;
    }

    public compareServices = (o1: any, o2: any) => {
        if (!o1 || !o2) {
            return false;
        }
        return o1.id === o2.id;
    }

    constructor(public dialogRef: MatDialogRef<VendorComponent>,
                public userSvc: UserService,
                private notify: NotificationService,
                private shipmentPriceSvc: ShipmentPriceService,
    ) {

    }

    ngOnInit(): void {
        this.form = this.initializeForm();

        this.subscribePhoneNumber();
    }

    private initializeForm(): FormGroup {
        let countryIso2 = 'us';
        if (this.countries.length > 0 && this.vendor?.countryPhoneCode) {
            countryIso2 = this.getDialCode(this.vendor?.countryPhoneCode);
        }
        return new FormGroup({
            vendorId: new FormControl({disabled: true, value: this.vendor?.vendorId}),
            createdBy: new FormControl({disabled: true, value: this.vendor?.createdBy || ''}),
            name: new FormControl(
                this.vendor?.name || '',
                [
                    Validators.required,
                    Validators.maxLength(this.nameMaxLength),
                ]),
            contactName: new FormControl(
                this.vendor?.contactName || '',
                [
                    Validators.required,
                    Validators.maxLength(this.nameMaxLength),
                ]),
            countryPhoneCode: new FormControl(
                this.vendor?.countryPhoneCode || '1', [
                    Validators.required,
                ]),
            countryIso2: new FormControl(countryIso2),
            phoneNumber: new FormControl(this.vendor?.phoneNumber, [cellPhoneValidatorNew()]),
            email: new FormControl(
                this.vendor?.email || '', [
                    Validators.required,
                    Validators.email,
                    emailValidator(),
                ]),
            countryId: new FormControl(
                this.vendor?.countryId,
                [
                    Validators.required,
                ]),
            partnerName: new FormControl({disabled: true, value: this.vendor?.partner?.contactName || ''}),
            services: new FormControl(this.vendor?.vendorsServices, [Validators.required]),
            // subServices: new FormControl(this.vendor?.subService, [Validators.required]),
        });

    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    public onNoClick(): void {
        this.dialogRef.close();

    }

    public onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.notify.showError('Not all fields are filled');
            return;
        }
        if (this.createMode) {
            this.save(this.form.value);
        } else {
            this.update(this.vendor.id, this.form.value);
        }
    }

    private save(vendor: IVendor): void {
        this.showLoader = true;
        vendor.createdBy = this.userSvc.user.email;
        this.shipmentPriceSvc.create<IVendor>('vendor', vendor).subscribe((v) => {
            this.notify.showSuccessMessage(`Vendor ${v.name} was created successfully`);
            this.dialogRef.close(this.form.value);
        }, this.errorHandler);
    }

    private update(id: number, vendor: IVendor): void {
        this.showLoader = true;
        this.shipmentPriceSvc.update<IVendor>('vendor', id, vendor).subscribe((v) => {
            this.notify.showSuccessMessage(`Update successfully`);
            this.dialogRef.close(this.form.value);
        }, this.errorHandler);
    }

    private getDialCode(phoneCode): string {
        const country = this.countries?.find((c) => c.phoneCode === phoneCode);
        return country?.code.toLowerCase();
    }

    public getFlagClass(id): string {
        const country = this.countries?.find((c) => c.id === id);
        return `iti__${country?.code.toLowerCase()}`;
    }

    public getCountryNameByCode(id): string {
        return this.countries?.find((c) => c.id === id)?.name;
    }

    public hasErrors(error): void {
        if (!error) {
            this.form?.controls.phoneNumber.setErrors({'incorrect': !error});
        } else {
            this.form?.controls.phoneNumber.setErrors(null);
        }
    }

    public onCountryChange(phoneCode): void {
        this.form?.controls?.countryIso2.setValue(phoneCode.iso2);
        this.form?.controls?.countryPhoneCode.setValue(`+${phoneCode.dialCode}`);
    }

    public getNumber(e, field: string = 'phoneNumber', phoneCode: string = 'countryPhoneCode'): void {
        const value = e.replace(this.form?.controls[phoneCode]?.value, '');
        this.form.controls[field].setValue(value);
    }

    public telInputObject(event, name): void {
        this[name] = event;
    }

    subscribePhoneNumber() {
        this.form.get("countryId").valueChanges.subscribe((value) => {
            try {
                const phoneNumberData = this.form.get('phoneNumber').value;
                if (value && (!phoneNumberData || phoneNumberData?.length <= 0)) {
                    const country = this.countries?.find((c) =>
                        c.id === value
                    );
                    const code = country?.code.toLowerCase();
                    const phoneCode = country?.phoneCode.replace(/\+/g, '');

                    this.form.get('countryPhoneCode').setValue(phoneCode);
                    this.form.get('countryIso2').setValue(code);
                    this.phoneObj.setCountry(code);
                }
            } catch (e) {
                const defaultCountryIso2: string = 'us';
                this.form.get('countryIso2').setValue(defaultCountryIso2);
                this.phoneObj.setCountry(defaultCountryIso2);
            }
        });
    }
}
